import { render, staticRenderFns, recyclableRender, components } from "./visitorApproval.vue?vue&type=template&id=168c30ce&scoped=true&"
var renderjs
import script from "./visitorApproval.vue?vue&type=script&lang=js&"
export * from "./visitorApproval.vue?vue&type=script&lang=js&"
import style0 from "./visitorApproval.vue?vue&type=style&index=0&lang=css&"
import style1 from "./visitorApproval.vue?vue&type=style&index=1&id=168c30ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c30ce",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "n_pages/visitorApproval/visitorApproval.vue"
export default component.exports